import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

import { Formatters } from 'Common/Helpers';
import { FALLBACK_IMAGE } from 'Common/Constants';

const QueueItem = ({ data = {}, isActive }) => {
  const hasImage = Boolean(data.Picture);
  const imageSrc = hasImage
    ? Formatters.prependBase64(data.Picture)
    : FALLBACK_IMAGE;
  return (
    !isActive && (
      <div className="small-card">
        <div className="small-card-image-wrapper">
          <Image
            fluid
            src={imageSrc}
            className="small-card-image"
            alt={`${data.FullName} Profile Picture`}
          />
        </div>
        <div className="title-card">{data.FullName}</div>
      </div>
    )
  );
};

QueueItem.propTypes = {
  data: PropTypes.object,
  isActive: PropTypes.bool,
};

export default QueueItem;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/queue/component/QueueItem.js